export const PRIMARYCOLOR = '#009688';
export const SECONDARYCOLOR = '#96000E';
export const ANALAGOUSCOLOR1 = '#005996';
export const ANALAGOUSCOLOR2 = '#00963D';
export const appBackgroundColor = 'white';
//export const appBackgroundColor = '#d9efed';

const typography = {
  fontFamily: '"Manrope", sans-serif',
  h1: {
    fontFamily: '"Anek Bangla", sans-serif',
    fontSize: 48,
  },
  h2: {
    fontFamily: '"Anek Bangla", sans-serif',
  },
  h3: {
    fontFamily: '"Anek Bangla", sans-serif',
  },
  h4: {
    fontFamily: '"Anek Bangla", sans-serif',
  },
  h5: {
    fontFamily: '"Anek Bangla", sans-serif',
  },
  h6: {
    fontFamily: '"Anek Bangla", sans-serif',
  },
  fontSize: 17,
  button: {
    textTransform: 'none',
  },
};

const components = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: '25px',
      },
    },
  },
};

/**
 * MUI theme options for the given palette mode. Use with createTheme(getThemeOptions(mode)).
 */
export function getThemeOptions(mode) {
  const isDark = mode === 'dark';
  return {
    palette: {
      mode,
      primary: {
        main: PRIMARYCOLOR,
      },
      secondary: {
        main: SECONDARYCOLOR,
      },
      background: isDark
        ? {
            default: '#121212',
            paper: '#1e1e1e',
          }
        : {
            default: appBackgroundColor,
            paper: '#ffffff',
          },
    },
    typography,
    components,
  };
}

/** @deprecated Prefer getThemeOptions('light') + createTheme for dynamic mode */
const ThemeSettings = getThemeOptions('light');

export default ThemeSettings;


